











































































import { Component, Vue, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer } from '@/api/installServer';
import HazardDetail from '@/views/inspectionContents/rectificationNotice/hazardDetail.vue';

@Component({
  components: {
    PagingUnit,
    CollapseTransition,
    HazardDetail,
  },
  mixins: [TableStripe],
})
export default class ReviewList extends Vue {
  @Watch('searchFormData.reviewedFlag')
  private searchDept(val: any) {
    this.queryDataForm.pageNo = 1;
    this.getReviewList();
  }
  @Watch('searchFormData.hazardContent')
  private searchHazardContent(val: any) {
    this.queryDataForm.pageNo = 1;
    this.getReviewList();
  }

  showList = true; // 控制显示的组件
  row: object = {}; // 传递一行的值

  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条
  searchFormData: any = {
    reviewedFlag: false,
    hazardContent: '',
  }; // 搜索栏的数据对象
  tableData: Array<any> = []; // 表格的数据对象

  private levelText: any = {
    D: '一般隐患III级(D)',
    C: '一般隐患II级(C)',
    B: '一般隐患I级(B)',
    A: '重大隐患(A)',
  };
  private reviewStatus: any = {
    0: '未复查',
    1: '已通过',
    2: '未通过',
  }; // 复查状态

  created() {
    this.getReviewList();
  }
  private getReviewList() {
    performanceServer
      .reviewList({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        reviewedFlag: this.searchFormData.reviewedFlag,
        hazardContent: this.searchFormData.hazardContent,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    this.getReviewList();
  }

  hazardInfo(data: any) {
    this.showList = false;
    this.row = data;
  }
  hazardDetailResponse() {
    this.showList = true;
    this.getReviewList();
  }
  backRectifyIndex() {
    this.$emit('backRectifyIndex');
  }
}
